import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export type BankTransactionState =
  | 'UNMATCHED'
  | 'SYSTEM_PROPOSED'
  | 'USER_PROPOSED'
  | 'MATCHED'
  | 'MANUAL_CORRECTION';

export type BankTransactionType = 'CREDIT' | 'DEBIT';

export default class BankTransactionModel extends Model {
  @attr declare bankAccount: string;
  @attr declare state: BankTransactionState;
  @attr declare amount: number;
  @attr declare transactionType: BankTransactionType;
  @attr declare transactionSubtype: string;
  @attr declare bankReference: string;
  @attr declare customerReference: string;
  @attr declare addendaData: Record<string, unknown>;
  @attr declare tioData: Record<string, unknown>;
  @attr declare details: Record<string, unknown>;
  @attr declare transactionDate: string;
  @attr declare availableDate: string;
  @attr declare originatorId: string;
  @attr declare originatorBank: string;
  @attr declare originatorName: string;
  @attr declare bankFileId: number;

  [Type] = 'bank-transaction' as const;

  get isUnmatched(): boolean {
    return this.state === 'UNMATCHED';
  }

  get isSystemProposed(): boolean {
    return this.state === 'SYSTEM_PROPOSED';
  }

  get isUserProposed(): boolean {
    return this.state === 'USER_PROPOSED';
  }

  get isMatched(): boolean {
    return this.state === 'MATCHED';
  }

  get isCredit(): boolean {
    return this.transactionType === 'CREDIT';
  }

  get isDebit(): boolean {
    return this.transactionType === 'DEBIT';
  }

  get formattedAmount(): string {
    const amount = this.amount / 100;
    const prefix = this.isCredit ? '+' : '-';
    return `${prefix}$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  get proposedMatch(): Record<string, unknown> | null {
    return (this.tioData?.proposed as Record<string, unknown>) || null;
  }
}
